import {
  type CanvasElement,
  type LayoutData,
  NS_HOST_TYPE_PREFIX,
} from '@blaze-runtime/engine-domain';
import { type PageType } from '@blaze-shared/api-contracts-domain';

import { hasSlots } from './element-props-guards';

/**
 * Determines which layout types need to be loaded based on the provided elements.
 * @param elements
 */
export function getLayoutTypesToLoad(elements: CanvasElement[]): PageType[] {
  const pageTypesToLoad = new Set<PageType>();

  for (const element of elements) {
    if (!hasSlots(element)) {
      continue;
    }

    for (const slotId of element.slots.ids) {
      if (
        slotId.startsWith(NS_HOST_TYPE_PREFIX) &&
        element.slots[slotId]?.hosting?.ns === undefined
      ) {
        pageTypesToLoad.add(slotId.slice(NS_HOST_TYPE_PREFIX.length + 1) as PageType);
      }
    }
  }

  return Array.from(pageTypesToLoad);
}

/**
 * Checks if the layout was modified by the fronted.
 * @param layout
 */
export function isLayoutModified(layout: LayoutData): boolean {
  return !(layout.version === 0 && layout.uiLayer.content.length === 0);
}
